const ResumeData = {
  main: {
    name: "Rahul Nisanth",
    description:
      "A dedicated and enthusiastic computer science student actively working towards a bachelor's degree. Beyond technical prowess, I bring a multifaceted approach to my work with a penchant for project management",
    image: "profilepic.jpeg",
    bio: "I'm a passionate computer science student and aspiring software engineer, committed to solving real-world problems with creative and innovative solutions. With a strong technical foundation and a growing proficiency in system design, I aim to contribute to impactful software development projects while continuously expanding my knowledge.",
    contactmessage:
      "Let's connect and explore the boundless possibilities that the world of Computer Science has to offer!",
    email: "rahulnisanthmuthukumar@gmail.com",
    phone: "+91-6374422349",
    github: "https://github.com/Rahulnisanth/",
    leetcode: "https://leetcode.com/rahulnisanth",
    address: {
      street: "Aspiring Software Engineer",
      city: "Coimbatore",
      state: "Tamilnadu",
      zip: "641062",
    },
    website: "http://linktr.ee/Rahulnisanth",
    social: [
      {
        name: "codolio",
        url: "https://codolio.com/profile/rahul_nisanth",
        className: "fa fa-puzzle-piece",
      },
      {
        name: "instagram",
        url: "http://instagram.com/rahul_nisanth",
        className: "fa fa-instagram",
      },
      {
        name: "linkedin",
        url: "https://www.linkedin.com/in/rahul-nisanth/",
        className: "fa fa-linkedin",
      },
      {
        name: "github",
        url: "https://github.com/Rahulnisanth",
        className: "fa fa-github",
      },
      {
        name: "leetcode",
        url: "https://leetcode.com/rahulnisanth",
        className: "fa fa-code",
      },
    ],
  },
  resume: {
    skillmessage:
      "I possess a strong command over several programming languages along with some web essentials.",
    education: [
      {
        school: "Sri Shakthi Institute of Engineering and Technology",
        degree: "Bachelor of Computer Science Engineering",
        graduated: "Oct 2022 - Oct 2026",
        grade: "8.3 CGPA",
        description:
          "My college education was a pivotal chapter in my life, marked by academic exploration, personal growth, and newfound independence.",
      },
      {
        school: "Vigneshwar Vidhya Mandhir",
        degree: "Higher Education",
        graduated: "Jun 2020 - Jun 2022",
        grade: "91.2 %",
        description:
          "My higher education experience was a transformative period of intellectual growth, where I delved deep into my chosen field of study and explored new perspectives.",
      },
      {
        school: "Venkitaraj Matriculation School",
        degree: "Primary Education",
        graduated: "Jun 2008 - Jun 2020",
        grade: "96.8 %",
        description:
          "My primary education experience was a transformative period of intellectual growth, where I delved deep into my chosen field of study and explored new perspectives.",
      },
    ],
    experience: [
      {
        company: "AboveCloud9.ai",
        title: "Software Engineer - Internship",
        years: "Oct 2024 - Now",
        description:
          "Collaborated with senior developers to build robust mobile applications using Flutter, SwiftUI and GoLang. Completed assigned tasks within given deadlines to ensure project success.",
      },
    ],
    skills: [
      {
        name: "Python",
        level: "70%",
      },
      {
        name: "GoLang",
        level: "30%",
      },
      {
        name: "React",
        level: "70%",
      },
      {
        name: "NextJs",
        level: "40%",
      },
      {
        name: "Flutter",
        level: "50%",
      },
      {
        name: "Tailwind",
        level: "70%",
      },
      {
        name: "NodeJs",
        level: "40%",
      },
      {
        name: "Express",
        level: "40%",
      },
      {
        name: "SQL",
        level: "75%",
      },
      {
        name: "MongoDB",
        level: "65%",
      },
    ],
  },
  portfolio: {
    projects: [
      {
        title: "Synapses",
        category: "Synapses is a fully responsive real-time chat application.",
        tags: ["MongoDb", "Express", "React", "Node", "SocketIO"],
        image: "08.png",
        url: "https://synapses-chat-app.vercel.app/",
        session: "completed",
      },
      {
        title: "Track It Now",
        category: "An e-commerce price tracker & analyzer for best deals",
        tags: ["WebScraping", "NextJs", "Cheerio", "MongoDB"],
        image: "07.png",
        url: "https://track-it-now.vercel.app/",
        session: "completed",
      },
      {
        title: "Mind Wave",
        category:
          "Mind-Wave is a meditation app that provides a serene user experience through guided meditations and positive affirmations.",
        tags: ["React Native", "Native Wind", "Expo", "JavaScript"],
        image: "09.png",
        url: "http://www.github.com/Rahulnisanth/Mind-Wave/",
        session: "completed",
      },
      {
        title: "Blog Haven",
        category:
          "This is a blogging platform where users CRUD & manage blog posts.",
        tags: ["NextJs", "PostgreSQL", "Vercel"],
        image: "06.png",
        url: "https://bloghaven.vercel.app/",
        session: "completed",
      },
      {
        title: "Python Console Projects",
        category:
          "This repository consists of all my console-based projects using python.",
        tags: ["pythonProgramming", "consoleProjects"],
        image: "05.svg",
        url: "http://www.github.com/Rahulnisanth/CodSoft/",
        session: "completed",
      },
      {
        title: "BrandRoot Clothinx",
        category: "A Clothing based e-commerce site",
        tags: ["React", "Redux", "fireStore", "firebase"],
        image: "03.png",
        url: "http://brandroot-clothinx.netlify.app",
        session: "completed",
      },
      {
        title: "Tech Inferno Hub",
        category: "Projects based profile boosting platform",
        tags: ["MumbleUI", "JS", "Django", "SQL"],
        image: "02.png",
        url: "http://www.github.com/Rahulnisanth/TechInferno-Hub/",
        session: "completed",
      },
      {
        title: "Inceptron - 2k23",
        category: "A Landing Site for college hackathon.",
        tags: ["HTML", "CSS", "JS", "Flask"],
        image: "01.png",
        url: "http://www.inceptron.me/",
        session: "completed",
      },
    ],
  },
};

export default ResumeData;
